import AutoPlayButton from './AutoPlayButton';

const EventNavigationControls = ({selectedEvent,isReading,onPrevious,onGoToFirst,onReadingStateUpdate,onNext,onAutoPlayToggle,isAutoPlaying,onGoToLast}) => {
  return (
				<div className="flex items-center bg-white rounded-lg shadow-sm px-2 py-1 space-x-2">
				<button 
				  onClick={() => onGoToFirst()}
				  className={`text-gray-700 p-1 rounded-full transition-colors ${
					selectedEvent && !isReading ? 'hover:bg-gray-100' : 'opacity-50 cursor-not-allowed'
				  }`}
				  disabled={!selectedEvent || isReading}
				  aria-label="Go to first event"
				  title={isReading ? "Okuma devam ediyor..." : "İlk olaya git"}
				>
				  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
				  </svg>
				</button>
  
				<button 
				  onClick={() => onPrevious(selectedEvent)}
				  className={`text-gray-700 p-1 rounded-full transition-colors ${
					selectedEvent && !isReading ? 'hover:bg-gray-100' : 'opacity-50 cursor-not-allowed'
				  }`}
				  disabled={!selectedEvent || isReading}
				  aria-label="Previous event"
				  title={isReading ? "Okuma devam ediyor..." : "Önceki olay"}
				>
				  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
				  </svg>
				</button>
				
				<AutoPlayButton 
				  selectedEvent={selectedEvent}
				  isAutoPlaying={isAutoPlaying}
				  onAutoPlayToggle={onAutoPlayToggle}
				  onNext={onNext}
				  onUpdateReadingState={onReadingStateUpdate}
				/>
				
				<button 
				  onClick={() => onNext(selectedEvent)}
				  className={`text-gray-700 p-1 rounded-full transition-colors ${
					selectedEvent && (!isReading || !isAutoPlaying) ? 'hover:bg-gray-100' : 'opacity-50 cursor-not-allowed'
				  }`}
				  disabled={!selectedEvent || (isReading && isAutoPlaying)}
				  aria-label="Next event"
				  title={isReading && isAutoPlaying ? "Okuma devam ediyor..." : "Sonraki olay"}
				>
				  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
				  </svg>
				</button>
  
				<button 
				  onClick={() => onGoToLast()}
				  className={`text-gray-700 p-1 rounded-full transition-colors ${
					selectedEvent && !isReading ? 'hover:bg-gray-100' : 'opacity-50 cursor-not-allowed'
				  }`}
				  disabled={!selectedEvent || isReading}
				  aria-label="Go to last event"
				  title={isReading ? "Okuma devam ediyor..." : "Son olaya git"}
				>
				  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7m-8-14l7 7-7 7" />
				  </svg>
				</button>
			  </div>
  )
}

export default EventNavigationControls